import { useEffect, useState } from "react";
import { ArrowUp } from "lucide-react";
import { getLenis } from "../../lib/lenis";

export const BackToTop = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 300);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const toTop = () => {
    const lenis = getLenis();
    if (lenis) lenis.scrollTo(0);
    else window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <button
      type="button"
      onClick={toTop}
      aria-label="Back to top"
      data-testid="back-to-top"
      className={`fixed bottom-24 right-5 sm:right-7 z-30 w-11 h-11 rounded-full bg-nx-goldlight text-nx-navy flex items-center justify-center shadow-lg shadow-black/40 hover:bg-nx-gold hover:-translate-y-1 transition-all duration-300 ${visible ? "opacity-100 pointer-events-auto" : "opacity-0 pointer-events-none translate-y-3"}`}
    >
      <ArrowUp size={19} strokeWidth={2.5} />
    </button>
  );
};
